module.exports = __webpack_public_path__ + "static/media/notice.b5339981.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/scene/icon/notice.svg
// module id = 277
// module chunks = 0